import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-tender',
  templateUrl: './tender.component.html',
  styles: []
})
export class TenderComponent implements OnInit {
  userGroups: number[] = [];
  creator = false;
  constructor(private translate: TranslateService, private globalSrv: GlobalServices,
    private authSrevice: AuthenticationService,
    private etenderSrv: EtenderService) { }

  ngOnInit() {
    this.getUserGroups();
  }
  getUserGroups() {
    this.etenderSrv.GetUserGroups(this.authSrevice.currentUserValue.Email).subscribe(
      data => {
        this.userGroups = data.Data;
        if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderCreators ||
          a == ETenderAdminTypes.SCAServices_ETenderPurchasingCategoryAdmins).length > 0) {
          this.creator = true;
        }
      },
      () => console.log('Something went wrong!!')
    );
  }
}
